module.exports = __webpack_public_path__ + "img/titleIcon.a02edb04.svg";